import { Controller } from "@hotwired/stimulus"

// Client picker for the agent settings page. Swaps which setup panel is shown
// and keeps the tablist keyboard-navigable (arrow keys, Home, End).
//
// Usage:
//   div data-controller="agent-tabs"
//     button data-agent-tabs-target="tab" data-panel="claude-code"
//            data-action="click->agent-tabs#select keydown->agent-tabs#navigate"
//     div    data-agent-tabs-target="panel" data-panel="claude-code"
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const active = this.tabTargets.find((t) => t.classList.contains("is-active")) || this.tabTargets[0]
    if (active) this.#activate(active.dataset.panel)
  }

  select(event) {
    this.#activate(event.currentTarget.dataset.panel)
  }

  navigate(event) {
    const keys = ["ArrowRight", "ArrowLeft", "Home", "End"]
    if (!keys.includes(event.key)) return
    event.preventDefault()

    const tabs = this.tabTargets
    const current = tabs.indexOf(event.currentTarget)
    let next = current

    if (event.key === "ArrowRight") next = (current + 1) % tabs.length
    if (event.key === "ArrowLeft") next = (current - 1 + tabs.length) % tabs.length
    if (event.key === "Home") next = 0
    if (event.key === "End") next = tabs.length - 1

    this.#activate(tabs[next].dataset.panel)
    tabs[next].focus()
  }

  #activate(panel) {
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.panel === panel
      tab.classList.toggle("is-active", on)
      tab.setAttribute("aria-selected", on ? "true" : "false")
      tab.setAttribute("tabindex", on ? "0" : "-1")
    })

    this.panelTargets.forEach((el) => {
      const on = el.dataset.panel === panel
      el.classList.toggle("is-active", on)
      el.hidden = !on
    })
  }
}
